import { useLazyQuery } from "@apollo/client/react";




































export const useDataClientLazyQuery = useLazyQuery;
